import { render, staticRenderFns } from "./ReportOrganisationDashboard.vue?vue&type=template&id=72fa8316"
import script from "./ReportOrganisationDashboard.ts?vue&type=script&lang=ts&external"
export * from "./ReportOrganisationDashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./ReportOrganisationDashboard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports